import { defaultsDeep } from 'lodash-es';

import { BufferConfig } from '@dtvgo/player-common-utils';

import { IS_BRAZIL } from './constants';

export type TokenType = 'queryParam' | 'header' | 'cookie';

export interface AppConfig {
  lowLatency: boolean;
  parentalControl: boolean;
  shakaVersion: string;
  buffer: {
    live: BufferConfig;
    vod: BufferConfig;
  };
  cdnTokenizationTokenType: TokenType[];
  metadata: {
    live: {
      retryCount: number;
      retryDelaySecs: number;
      fakeScheduleDefaultDurationMins: number;
      cacheSize: number;
      isDelayedWindowSecs: number;
    };
    vod: Record<string, never>;
  };
  recovery: {
    baseDelay: number;
    maxReloadTime: number;
    maxAttempts: number;
    resetTime: number;
    backoffFactor?: number;
    fuzzFactor?: number;
  };
  heartbeat: {
    timeInSeconds: number;
    useStreamingV4: boolean;
    useStopV4: boolean;
  };
  goToLiveLongPauseMinutes: number;
}

const DEFAULT_APP_CONFIG: AppConfig = {
  lowLatency: false,
  parentalControl: !!IS_BRAZIL,
  shakaVersion: '4.15.12',
  buffer: {
    live: {
      forward: 30,
      backward: 30,
    },
    vod: {
      forward: 30,
      backward: 60,
    },
  },
  cdnTokenizationTokenType: ['queryParam'],
  metadata: {
    live: {
      retryCount: 3,
      retryDelaySecs: 5,
      fakeScheduleDefaultDurationMins: 15,
      cacheSize: 4,
      isDelayedWindowSecs: 10,
    },
    vod: {},
  },
  recovery: {
    baseDelay: 1000,
    maxReloadTime: 20_000,
    maxAttempts: 3,
    resetTime: 10_000,
    backoffFactor: 2,
    fuzzFactor: 0.5,
  },
  heartbeat: {
    timeInSeconds: 90,
    useStreamingV4: true,
    useStopV4: false,
  },
  goToLiveLongPauseMinutes: 10,
};

/**
 * Returns a Promise that resolves to the app config. The config
 * is fetched from a remote source and defaults to a hardcoded
 * config if the fetch fails.
 */
export function getAppConfig() {
  return fetchAppConfig()
    .then((data) => defaultsDeep({}, data, DEFAULT_APP_CONFIG) as AppConfig)
    .catch((error) => {
      console.error('[getAppConfig] Failed to fetch app config', error);
      return DEFAULT_APP_CONFIG;
    });
}

function fetchAppConfig() {
  // TODO: Replace Promise.resolve({}) to real remote config API call
  return Promise.resolve({});
}
